export type BarcodeFormat = 'ITF' | 'QRCode';

export const SCAN_INTERVAL_MS = 150;

const NATIVE_BARCODE_FORMAT_MAP: Record<BarcodeFormat, string> = {
  ITF: 'itf',
  QRCode: 'qr_code',
};

export function toNativeBarcodeFormat(format: BarcodeFormat): string {
  return NATIVE_BARCODE_FORMAT_MAP[format];
}

export interface MediaDevicesLike {
  getUserMedia?: (constraints: MediaStreamConstraints) => Promise<MediaStream>;
}

export function isCameraAvailable(mediaDevices: MediaDevicesLike | undefined | null): boolean {
  return Boolean(mediaDevices?.getUserMedia);
}

export function isPermissionDeniedError(error: unknown): boolean {
  if (error instanceof DOMException) {
    return error.name === 'NotAllowedError' || error.name === 'PermissionDeniedError';
  }

  if (error && typeof error === 'object' && 'name' in error) {
    const name = (error as { name?: unknown }).name;
    return name === 'NotAllowedError' || name === 'PermissionDeniedError';
  }

  return false;
}

export function hasNativeBarcodeDetector(): boolean {
  return typeof window !== 'undefined' && 'BarcodeDetector' in window;
}
